import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { isDevMode } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

// Import the AuthService type from the SDK
// import { AuthService } from '@auth0/auth0-angular';
// import Cache from '@aws-amplify/cache';

import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { AccessGroupService } from "./components/access-group.service";
import { Location, DOCUMENT } from "@angular/common";
import { CommonDataService } from "./components/common-data.service";
import { Injectable } from "@angular/core";
import { filter } from "rxjs/operators";
// import { VersionCheckService } from "./version-check.service";
import { environment } from "../environments/environment";
import { HttpClient } from "@angular/common/http";
// import { Auth } from "./auth/auth.service";
// import { generateClient } from 'aws-amplify/data';
// import { Schema } from './../../amplify/data/resource';

// store
import { select, Store } from "@ngrx/store";
import * as fsProfileActions from "./store/action/fs.action";
import {OidcSecurityService} from 'angular-auth-oidc-client';
import Swal from 'sweetalert2';
import { SessionExpiredService } from './auth/session-expired.service';

const PUBLIC_ROUTES = ['thinking-coach', 'challenge-navigator-print-coach', 'public-store', 'share-profile', 'group-profile', 'assessments'];

// const client = generateClient<Schema>();

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  public menu_items: any;
  public email: any;
  public referrer: any;
  public profile: any;

  storeNgrx: any;

  // Check for Authentication
  isAuthenticated: boolean;

  shouldDisplayOverlay: boolean = true;

  routerSubscription: Subscription;

  constructor(
    // public versionCheckService: VersionCheckService,
    // private authService: Auth,
    public oidcSecurityService: OidcSecurityService,
    private router: Router,
    public service: CommonDataService,
    public location: Location,
    public http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
    public store: Store<any>,
    private sessionExpiredService: SessionExpiredService,
  ) {
    // console.log("appMode:-",isDevMode());
    // Update Token for OIDC
    // this.authService.getIdTokenClaims().subscribe(message => {
    //     if(message.__raw){
    //     Cache.setItem('federatedInfo', { token: message.__raw });
    //     }else{
    //     console.log('TOKEN FAILURE!');
    //     }

    // });

    // this.startCounter();

    // hash-based routing
    // auth.handleRedirectCallback();
    // authService.handleAuthentication();

    // Attempt single sign-on authentication
    // if not authenticated
    // if (auth.isAuthenticated()) {
    //   this.shouldDisplayOverlay = false;
    // } else {
    //   auth.renewToken();
    // }
    // authService.scheduleRenewal();
    this.isAuthenticated = false;
  }

  ngOnInit() {
    var that = this;
    this.storeNgrx = this.store.select<any>((state) => state.profile.accessGroupData)
    this.oidcSecurityService.checkAuth().subscribe((loginResponse) => {
        const { isAuthenticated, userData, accessToken, idToken, configId } =
          loginResponse;
        // this.oidcSecurityService.getUserData(loginResponse.configId).subscribe(userData => {
        //   console.log("userData",userData);
        // })
        if(!loginResponse.isAuthenticated) {
          if(!window.location.href.includes('/impersonation') && localStorage.getItem('impersonation') !== 'true' && !window.location.href.includes('/reset-password') && !window.location.href.includes('/congratulations')){
            if(!window.location.href.includes('/store') && !window.location.href.includes('/challenge-navigator-print-coach') && !window.location.href.includes('/slideshow') && !window.location.href.includes('/thinking-coach') && !window.location.href.includes('/assessments')){
              this.router.navigate(['/login']);
            }
          }
          if(localStorage.getItem('impersonation') === 'true'){
            this.storeActions();
          }
        } else {
          // this.versionCheckService.initVersionCheck(environment.versionCheckURL);
          this.routerSubscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
              document.body.scrollTop = 0;
            });

            this.storeActions();

            let previouslyAuthenticated = true;
            this.oidcSecurityService.isAuthenticated$.subscribe(({ isAuthenticated }) => {
              this.isAuthenticated = isAuthenticated;
              if (!isAuthenticated && previouslyAuthenticated && !this.sessionExpiredService.popupShown) {
                const isPublicRoute = PUBLIC_ROUTES.some(r => this.router.url.includes(r));
                if (!isPublicRoute) {
                  this.performSessionLogout();
                }
              }
              previouslyAuthenticated = isAuthenticated;
            });
      
        }
      });
  }

  public storeActions() {
    // profile action
    this.store.dispatch(fsProfileActions.getProfile());
    // access group action
    this.store.dispatch(fsProfileActions.getAccessGroup());
  }

  private performSessionLogout(): void {
    if (this.sessionExpiredService.popupShown) return;
    this.sessionExpiredService.popupShown = true;
    this.oidcSecurityService.logoffLocal();
    const cnFrameworks = localStorage.getItem('CN_FRAMEWORKS');
    Swal.fire({
      title: 'Session Expired',
      text: 'Your session has expired. Please log in again.',
      icon: 'warning',
      confirmButtonText: 'Log In',
      confirmButtonColor: '#18a689',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      localStorage.clear();
      sessionStorage.clear();
      if (cnFrameworks) localStorage.setItem('CN_FRAMEWORKS', cnFrameworks);
      const redirectUri = encodeURIComponent(window.location.origin);
      window.location.href = `${environment.cognito.domain}/logout?client_id=${environment.cognito.clientId}&redirect_uri=${redirectUri}&response_type=${environment.cognito.responseType}`;
    });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  onActivate(e, scrollContainer) {
    scrollContainer.scrollTop = 0;
  }

  // SignOut
  public signOut(): void {
    // this.authService.logout();
  }
}
